var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 5,
    viewBox: "0 0 11 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.643562 0.232544C0.864944 -0.0441829 1.26874 -0.0890491 1.54547 0.132332L5.4224 3.23388L9.29933 0.132332C9.57606 -0.0890491 9.97985 -0.0441829 10.2012 0.232544C10.4226 0.50927 10.3777 0.913066 10.101 1.13445L5.82324 4.55667C5.58889 4.74415 5.2559 4.74415 5.02155 4.55667L0.743774 1.13445C0.467048 0.913066 0.422181 0.50927 0.643562 0.232544Z",
    fill: "#A2A8B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.7150af761e98e4d6c038ac6902787f49.svg";
export { ForwardRef as ReactComponent };